module.exports = __webpack_public_path__ + "assets/img/icon_qrcode_math_start.9b03d19d.png";